var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DefaultLayout',{ref:"defaultActions",scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('BarcodePlacement',{attrs:{"item-id":_vm.$route.params.itemId},on:{"barcodePlacementSaved":_vm.redirectToManageItems,"placeLater":_vm.redirectToManageItems}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }